import { QUERY_KEYS } from "@/libraries/constant";
import type { BodyUpdateMemberSchema } from "@/schemas/member";
import type { ResError, UpdateMemberResponse } from "@/types";
import { useMutation } from "@tanstack/react-query";

function useUpdateMember() {
	return useMutation<UpdateMemberResponse, ResError, BodyUpdateMemberSchema>({
		mutationKey: [QUERY_KEYS.MUTATE_MEMBER_UPDATE],
	});
}

export default useUpdateMember;
